import React, { Component } from 'react';

import PageHeader from '../../../shared/page-header/components/page-header';
import FaqItem from './faq-item';
import faqConstants from '../constants/faq-constants';

import '../styles/faq.css';

class Faq extends Component {
  renderFaqItems(items) {
    if (items && items.length > 0) {
      return items.map((item, index) => {
        return <FaqItem {...item} id={`faq-${index}`} key={index} />;
      });
    } else return null;
  }

  render() {
    return (
      <div className="faq-container row">
        <PageHeader title={'MENU.FAQ'} />
        {this.renderFaqItems(faqConstants.faqs)}
      </div>
    );
  }
}

export default Faq;



// WEBPACK FOOTER //
// ./src/app/main/faq/components/faq.js